export const ca = {
  ADD_COLOR_STRING_KEY: 'Add color',
  ADD_TEXT_KEY: 'Afegir text',
  ADD_TO_ORDER_KEY: 'Add to order',
  ADD_TO_CART: 'Afegir al carret',
  ADD_TEMPLATE: 'Add Template',
  ADJUST_SIZE_KEY: 'Adjust Size',
  ADJUST_TRANSPARENCY_KEY: 'Adjust Transparency',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    "By clicking Done, you agree to the HP's terms of use and privacy statement.",
  ALIGN_BOTTOM_KEY: 'Alinea al fons',
  ALIGN_CENTER_KEY: 'alinear centre',
  ALIGN_KEY: 'alinear',
  ALIGN_LEFT_KEY: 'Align Left',
  ALIGN_MIDDLE_KEY: 'alinear mig',
  ALIGN_RIGHT_KEY: 'Align Right',
  ALIGN_TOP_KEY: 'Alineació superior',
  ALL_TAB_TITLE_KEY: 'Tot',
  ALMOST_DONE_TITLE_KEY: 'Almost done!',
  AND_KEY: 'and',
  APPLY_KEY: 'Apply',
  AREA_CODE: 'Area code',
  BASIC_HELPER_INSTRUCTION1_KEY:
    'Browse the content and select the images for your design, or upload your own',
  BASIC_HELPER_INSTRUCTION2_KEY:
    'Preview your design, or fine-tune the details',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Customize the design and add other elements to your project',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'When the design is ready, click NEXT to make a final check and place your order.',
  BACK_KEY: 'Back',
  BACKGROUND_KEY: 'Fons',
  BACKGROUND_UPPER_CASE_KEY: 'BACKGROUND',
  BACKGROUND_CONTRAST_KEY: 'Background Contrast',
  BLANK_INSPIRATION_CATEGORY_KEY:
    'No hi ha inspiracions trobades en aquesta categoria',
  BRING_TO_FRONT_KEY: 'Porteu-ho al davant',
  CANCEL_TEXT_KEY: ' Cancel.lar',
  CENTIMETERS_KEY: 'centímetres',
  CM_KEY: 'cm.',
  CHANGE_YOUR_SETTINGS_KEY: 'Change your project settings',
  CHECKBOX_CONTENT1: 'I want to receive the Pattern Design© newsletter',
  CHECKBOX_CONTENT2:
    'I authorize HP to create an account in Pattern Design© services on my behalf',
  CHOOSE_FROM_COMPUTER_KEY: 'Choose from computer',
  CHOOSE_RIP_OPTIONS: 'Choose one of these compatible third party RIPs',
  CHOOSE_FILE_KEY: 'Escollir fitxer',
  CITY: 'City',
  CLEAR_ALL_KEY: 'Esborrar –ho tot',
  CLEAR_COLOR_KEY: 'Esborra el color',
  CLOSE_WINDOW_KEY: 'Tanca la finestra',
  CLEAR_ALL_OBJECTS: 'Esborrar tots els objectes',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'Això suprimirà tots els objectes del fons.',
  CLEAR_DESIGN_KEY: 'Clear design',
  COLOR_KEY: 'Color',
  CONTINUE_KEY: 'Continuar...',
  COMPANY: 'Company',
  CONGRATULATIONS_KEY: 'Congratulations!',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PATTERN_ACCOUNT_KEY: "Don't have a Pattern Design account yet?",
  CONFIRM_VECTEEZY_ACCOUNT_KEY: "Don't have a Vecteezy account yet?",
  COUNTRY: 'Country',
  CREATE_ACCOUNT: 'Create account',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Custom',
  CUSTOM_PRICE_SIGN_IN_KEY: 'Sign-in in the next step to see custom pricing.',
  CM_UNIT_KEY: 'cm',
  CREATE_NEW: 'Create new',
  DESIGN_KEY: 'Disseny',
  DELETE_KEY: 'Suprimir',
  DOCUMENT_COLORS: 'Colors del document',
  DONE: 'Done!',
  DONE_KEY: 'Fet',
  DONT_SHOW_ALERT_KEY: "Don't show again",
  DOWNLOAD_COLUMN_HEADER_KEY: 'Baixar',
  DOWNLOAD_APP_TITLE_KEY: "Podeu baixar l'aplicació aquí:",
  DOWNLOAD_LINK_KEY: 'Download HP Click for free here',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DOWNLOAD_INSTR_KEY: 'Make sure you have HP Click installed before continuing',
  DOWNLOAD_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Importació de Dropbox',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'The image size should be less than 1 GB. We accept pdf, png, jpg, svg and tiff formats.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Cerca de Dreamstime',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Imatges de Dreamstime',
  DUPLICATE_KEY: 'Duplicar',
  EACH_ITEM_PRICE_KEY:
    'Your design includes content from one of our premium content providers. The itemized pricing of each element is summarized below.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Edita el disseny',
  EDIT_LOWERCASE_KEY: 'edit',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    ' Ho sentim, s&apos;ha produït un error. Proveu-ho més tard.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    "Òndia, s'ha produït un error a l'obrir l'arxiu PDFcarregat.",
  EMAIL_KEY: 'Correu electrònic',
  EMAIL_ADDRESS_KEY: 'Adreça de correu electrònic:',
  EMAIL_CHECKBOX_MESSAGE:
    "Sé que aquesta persona comprén que rebrá correus electrònics d'HP en el meu nom o en nom d'aquest proveïdor de serveis.",
  EXTRA_INFO_KEY: 'Informació addicional',
  EMAIL_NOTIFICATION:
    'En breu rebreu un correu electrònic. Espereu fins a 15 minuts per al processament.',
  EMAIL_DIALOG_MESSAGE:
    'Indiqui la direcció de correu electrònic de la persona amb la que vol compartir el projecte.',
  ENTER_KEY: 'Enter',
  EXISTING_FOLDER_KEY: 'Carpeta existent',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'Assegureu-vos que els articles seleccionats són correctes abans de continuar amb el procés de pagament',
  FINAL_CHECK_TITLE_KEY: 'Comprovació final',
  FINISH_KEY: 'Finalitzar',
  FINISH_LATER_KEY: 'Finish later',
  FIRSTNAME: 'First name',
  FISCAL_NUM: 'Fiscal number',
  FLIP_KEY: 'Girar',
  FOR_KEY: 'per',
  FORGOT_PASSWORD_KEY: 'Forgot password?',
  FOTOLIA_KEYWORDS_KEY: 'Paraules clau:',
  FOLDER_NAME: 'Nom de la carpeta',
  FOLDER_NAME_KEY: 'Nom de la carpeta:',
  FOLDER_ALREADY_EXIST_KEY: "El nom d'aquesta carpeta ja existeix",
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    "You've just completed your free poster design",
  FREE_VECTOR_GRAPHICS_KEY: 'free vector graphics',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'Ok, I got it',
  GROUP_ALL_KEY: 'Agrupar –ho tot',
  GROUP_SCALE: 'Agrupar escala',
  GIFT_WRAPS_KEY: 'Gift Wraps',
  GIVE_PROJECT_NAME_KEY: 'Poseu un nom al vostre projecte',
  HEIGHT_KEY: 'Alçada',
  HELP_DESCRIPTION_KEY:
    'Let us walk you through the design process. Remember you can open the tour as many times as you want by clicking on the help icon.',
  HELP_KEY: 'Ajuda',
  HELPER_TITLE_KEY_1:
    'Create poster designs from a blank page or from millions of images and text. Upload your own content from local drives, Dropbox or social media',
  HELPER_TITLE_KEY_3: 'See all your design work in one place',
  HELPER_TITLE_KEY_4: 'Click Next to preview and finish your final design',
  HERE_KEY: 'here',
  HELP_IMPROVE_KEY:
    'Help improve your productivity and operator efficiency, and expand with color production.',
  HIGH_QUALITY_KEY: 'High-quality',
  IMAGES_TITLE_KEY: 'IMATGES',
  IMPERIAL_KEY: 'Imperial',
  IMPORTING_KEY: "S'està important",
  INCHES_COLUMN_HEADER_KEY: 'Polzades',
  INCHES_KEY: 'polzades',
  INCHES_UNIT_STRING_KEY: 'polzades',
  INVALID_EMAIL_ADDRESS_KEY: 'Adreça de correu electrònic no vàlida',
  INVALID_INFO_KEY: 'Please enter details.',
  INVALID_NAME_KEY: 'Nom no vàlid',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    "Ho sentim, però el fitxer seleccionat és massa gran. La mida màx. d'arxiu és de 500mb.",
  INSUFFICIENT_CREDITS_KEY: 'Insufficient credits',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiration',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    'Òndia, aquest no es un format de fitxer vàlid. Només treballem amb pdf, jpg, png, svg, i tif.',
  LANDSCAPE_KEY: 'Landscape',
  LANGUAGE_LABLE_KEY: 'Idioma',
  LASTNAME: 'Last name',
  LEARN_MORE: 'Més informació',
  LEARN_THE_BASICS_KEY: 'Learn the basics',
  LEGAL_FOOTER_MESSAGE1_KEY:
    "En utilitzar aquest lloc accepteu les obligacions d'aquestes",
  LEGAL_FOOTER_MESSAGE2_KEY: 'Aquest lloc web compleix amb',
  LEGAL_FOOTER_MESSAGE3_KEY: 'i',
  LENGTH_STRING_IN_INCHES_KEY: 'polzades',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'change',
  LINK_READER_APP_KEY: 'LinkReader App',
  LINK_READER_APP_DESCRIPTION_KEY:
    "Per visualitzar el contingut que afegiu, baixeu l'aplicació LinkReader.",
  LOADING_KEY: 'Carregant...',
  LOADING_TEMPLATE_KEY: 'Loading template',
  LOGIN_NOW: 'Login now',
  LOCK_KEY: 'Bloquejar',
  LOGIN_KEY: 'Iniciar sessió',
  LOGIN_PATTERN_DESIGN_KEY: 'Login to Pattern design',
  LOGIN_SUBTITLE_KEY: 'Login to see customized pricing and payment details',
  LOGIN_VECTEEZY_KEY: 'Login to Vecteezy',
  LOGIN_DREAMSTIME_KEY: 'Inicieu sessió a Dreamstime',
  LOGOUT_KEY: 'Tancar la sessió',
  MATERIAL_TITLE_KEY: 'MATERIAL',
  MATERIAL_STRING_KEY: 'Material',
  MEASUREMENT_KEY: 'Measurement',
  MINIMUM_ZOOM_WARNING:
    'No pot reduir-se més l&apos;escala d&apos;aquest fons ja que heu arribat a l&apos;alçada o amplada mínima necessària per cobrir la vostra paret.',
  METRIC_KEY: 'Metric',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'Model',
  MORE_INFO_TEXT_KEY: 'Més informació',
  MY_GIFTWRAPS_KEY: 'My Gift Wraps',
  MY_WORK_KEY: 'My work',
  MY_WORK_SAVE_KEY: 'Your design has been saved to your My Work space',
  NAME_KEY: 'Nom:',
  NEXT_BUTTON_TITLE_KEY: 'SEGÜENT',
  NEW_FOLDER_KEY: 'Nova carpeta',
  NO_SHADOW_KEY: 'Sense ombres',
  OBJECT_QUANTITY_KEY: 'Quantity',
  OBJECTS_UPPER_CASE_KEY: 'OBJECTS',
  OK_KEY: 'Acceptar',
  ORDER_SAMPLE_KEY: 'Mostra de comanda',
  ORDER_SAMPLE: 'Sol·licitar una mostra',
  ORDER_SAMPLE_INFOLABEL_1:
    'Seleccioneu la part de la imatge que vulgueu demanar com a mostra',
  ORDER_SAMPLE_INFOLABEL_2:
    'Rebreu un correu electrònic amb una vista detallada del projecte a mida real',
  ORDER_SAMPLE_INFOLABEL_3:
    'Això us ajudarà a valorar-ne la qualitat i la resolució',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: "Demana'n una mostra ara",
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'Rebi un correu electrònic amb una visualització en primer pla del vostre projecte a mida real per a avaluar la seva qualitat i resolució.',
  ORIENTATION_KEY: 'Orientation',
  OTHER_PRINTING_OPTIONS: 'Other printing options',
  PASSWORD_KEY: 'Contrasenya',
  PATTERN_COLOR_KEY: 'Pattern Color',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'patterns for',
  PDF_GENERATION_ERROR_MESSAGE_KEY: 'Failed to generate pdf. Please try again.',
  PHOTOS_KEY: 'PHOTOS',
  PHOTO: 'photo',
  PHONE: 'Phone',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    "Tinc els drets d'autor d'aquesta imatge i accepto",
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'The image size should be less than 500 MB. We accept png, jpg, tiff, svg and pdf formats.',
  PIXEL_COLUMN_HEADER_KEY: 'Píxel',
  PININTEREST_KEY: 'Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'cm',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Enter text here...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'És a dir, coses importants que vulgueu comunicar a la impremta',
  PLACEHOLDER_INCHES_STRING_KEY: 'polzades',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'My Poster',
  PORTRAIT_KEY: 'Portrait',
  POSITION: 'Posició',
  PREMIUM_IMAGES_TITLE_KEY: 'Premium images:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'Desa el teu projecte',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'El vostre projecte té canvis que han de desar-se abans de continuar.',
  PRICE_COLUMN_HEADER_KEY: 'Preu',
  PRINTER_SERIAL_NUMBER_KEY: 'Printer serial number*',
  PRINTING_ENABLE_DETAILS_KEY:
    'To enable printing we just need a few more details',
  PRINTER_MODELS_KEY: 'Printer models*',
  PROCESSING_KEY: 'Processant...',
  PROCESSING_ALERT_TXT:
    'Do not close this window while we are processing your design',
  PROCESSING_ALERT_TXT2:
    'Once processing has been completed, HP Click will open automatically and start downloading your file',
  PROCESSING_DONE: 'You are almost done!',
  PROCESSING_FILE_TXT: 'Your file is being processed.',
  PROCESSING_TIME_TXT:
    'This may take some time as we are composing your creation to ensure the best image quality',
  PROCESSING_ALERT_TXT3:
    'Your PDF will be automatically downloaded to your computer',
  PROCESSING_ALERT_TXT4:
    'Remember you can configure your JDF connection for automation in settings',
  PREMIUM_CONTENT_KEY: 'Premium Content',
  PREVIEW_KEY: 'Visualització prèvia',
  PROFESSIONAL_USE_TITLE_KEY: 'professional use.',
  PROJECT_NAME_KEY: 'Nom de projecte',
  PROJECT_NAME: 'Nom de projecte:',
  PROJECT_ALREADY_EXIST_KEY: "El nom d'aquest projecte ja existeix",
  NONUNIQUE_PROJECT_NAME_MESSAGE: "El nom d'aquest projecte ja existeix",
  NONUNIQUE_FOLDER_NAME_MESSAGE: "El nom d'aquesta carpeta ja existeix",
  PIXELATION_WARNING_KEY: 'Advertència de pixelat',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'A causa de la resolució de la foto que heu penjat, és possible que la vostra pell estigui distorsionada o distorsionada. Per assegurar-vos que no hi ha desenfocament, pengeu una imatge de bona qualitat i eviteu estirar-la. Si esteu satisfet amb la previsualització i voleu continuar, continueu enviant.',
  REGISTER_CONTACTINFO: 'Contact information',
  REGISTER_INFO: 'Register information',
  REGISTER_PATTERNSUB1: 'As a value HP customer,',
  REQUIRED_FIELDS_KEY: 'Required fields',
  REQUIRED_FIELDS_TEXT_KEY: 'Required fields',
  REQUIRED_STRING_KEY: 'REQUERIT',
  RECOLOR_KEY: 'Torna a aplicar color',
  RADICALLY_SIMPLE_KEY: 'Radically simple printing software',
  RIPSELECTION_HEAD:
    'This is your first time, select your prefered compatible printing software',
  RIPSELECTION_DESC:
    'Your selection will become your default printing option path for future print outs. Changes can be made later in settings',
  REGISTER_COMPANYINFO: 'Company information',
  REGISTER_KEY: 'Register',
  REGISTER_NOW: 'Register now',
  REOLOR_KEY: 'Torna a aplicar color',
  REQUEST_SAMPLE_KEY: 'Sol·licita una mostra',
  RESIZE_KEY: 'Resize',
  RESIZE_ARBITRARILY_KEY: 'Resize Arbitrarily',
  RESIZE_PROPORTIONALLY_KEY: 'Resize Proportionally',
  REVIEW_AND_SUBMIT_KEY: 'Review and Submit',
  REQUEST_FOR_QUOTATION: 'Sol·licitud de pressupost',
  RIGHT_LOGO_TEXT_KEY: 'de',
  ROTATE_KEY: 'Girar',
  ROTATE_LEFT_KEY: "Rotar 90º a l'esquerra",
  ROTATE_RIGHT_KEY: 'Rotar 90º a la dreta',
  ROTATION_KEY: 'Rotació',
  ROWS_COLUMN_LABEL_STRING_KEY: 'Files i columnes',
  ROYALTY_FREE_KEY: 'royalty-free',
  ROYALTY_KEY: 'royalty',
  SALUTATION: 'Salutation',
  SAVE_KEY: 'Desar',
  SAVING_KEY: 'Desant...',
  SAVE_INSPIRATION: 'Save inspiration',
  SAVE_TEMPLATE: 'Save template',
  SAVE_DIALOG_TITLE: 'Desa el teu projecte',
  SAVE_PROJECT_NAME_KEY: 'Desa en primer lloc el teu projecte',
  SAVEDIALOG_MESSAGE:
    'Inicieu sessió per desar el vostre projecte. Si no teniu un compte, us ajudarem a crear-ne un. Es perdrà el vostre progrès.',
  SEAMLESS_KEY: 'seamless',
  SCALE_INFO_STRING_KEY: 'Scale the image to fit with on your design',
  SCALE_KEY: 'Ajustar la mida',
  SCALE_ALL_KEY: 'Ajustar la mida de tot',
  SCALE_TO_FILL_KEY: 'Scale To Fill',
  SEARCH_BUTTON_TITLE_KEY: 'Cerca',
  SELECT_CUSTOM_SIZE_KEY: 'Select custom size',
  SELECT_CUSTOM_KEY: 'Custom',
  SEARCH_TITLE: 'Cerca',
  SELECTED_IMAGE_KEY: ' Selected Image: ',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Select Gift Wraps size',
  SELECT_COUNTRY: 'Select Country',
  SELECT_SALUTATION: '---Select---',
  SELECT_POSTER_SIZE_KEY: 'Select poster size',
  SELECT_PRINTING_OPTION_KEY: 'Select your prefered printing option',
  SEND_INSTALLATION_INSTRUCTION_KEY: "Envia'm instruccions de la instal·lació",
  SEND_TO_BACK_KEY: 'Enviar-ho al darrere',
  SEND_KEY: 'Enviar',
  SEND_TO_PRINT_TITLE_KEY: 'Send to print',
  SET_SIZE_KEY: 'Establir mida',
  SETTINGS_KEY: 'Configuració',
  SETTINGS_UPPERCASE_KEY: 'SETTINGS',
  SHARE_KEY: 'Enviar correu electrònic',
  SIGNED_IN_AS_KEY: 'Signed in as',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Sign in or register to see customized pricing and payment details',
  SIGN_UP_NOW_KEY: 'Sign up now',
  SKIP_KEY: 'Skip',
  SOLID_COLORS_KEY: 'Solid Colors',
  SQFT_UNIT_STRING_KEY: 'sq. ft.',
  SQM_UNIT_STRING_KEY: 'metres quadrats',
  START_TOUR_KEY: 'Start tour',
  STATUS_MSG: 'Your file has been sent to print!',
  SUBMIT_BUTTON_KEY: 'Presentar',
  SHARE_LINK_LABEL: "Seleccioni el tipus d'accés que desitja compartir",
  SHARE_EDIT_LINK: 'Edició',
  SHARE_VIEW_LINK: 'Visualització',
  SHARE_YOUR_CREATION: 'Share your creation!',
  STREET_ADD: 'Street address',
  TARGET_VIEWING_HINT:
    '* La distància de visualització objectiu es pot modificar des de la configuració.',
  TERMS1_KEY: 'condicions',
  TERMS2_KEY: "Declaració de privadesa d'HP",
  TERMS3_KEY: "Avís de drets de dades personals d'HP",
  TERMS_OF_USE_KEY: 'Terms of use',
  TERMS_OF_USE: 'Condicions d&apos;ús',
  TEXT_SHADOW_COLOR_KEY: 'Text shadow Color',
  TEXT_UPPERCASE_KEY: 'TEXT',
  TILE_KEY: 'Crea un mosaic',
  TOTAL_KEY: 'TOTAL',
  TOTAL_PRICE_KEY: 'Total:',
  TRANSPARENCY_KEY: 'Transparency',
  TEMPLATES_KEY: 'templates',
  TEMPLATES_UPPER_CASE_KEY: 'TEMPLATES',
  THANK_YOU_KEY: 'Gràcies',
  TWITTER_KEY: 'Twitter',
  UNLOCK_KEY: 'Desbloquejar',
  UNGROUP_KEY: 'Desagrupar',
  UPDATE_TEXT_KEY: 'Actualitzar',
  UPLOAD_KEY: 'importar imatge',
  UPLOAD_LOGO_KEY: 'Upload logo',
  UPLOAD_IMAGE_KEY: 'Upload your own image',
  UPLOAD_UPPERCASE_KEY: 'UPLOAD',
  USER_NAME: "Nom d'usuari",
  USER_TYPE_TITLE_KEY: 'What type of user are you*',
  UNTILE_KEY: 'Desfés el mosaic',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Search',
  VALIDITY_KEY: 'Validesa',
  VANILLA_LOGIN_DIALOG_KEY:
    'Join for free to save and print your design and see your saved work',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'This is the preview of your design, check the design is final before proceeding or select edit to make any changes',
  VAT_KEY: 'IVA',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'vector',
  VIEW_FOTOLIA_KEY: 'Veu a Fotolia©',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'Mostra els detalls del disseny',
  VIEW_DESIGNER_PROFILE_KEY: 'Mostra el perfil de dissenyador',
  VIEW_PRICE_KEY: 'Veure el preu',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Search',
  WALL_POSTER_KEY: 'Pòster de paret',
  WALL_SIZE_TEXT_KEY: 'Wall size',
  WARNING_KEY: 'Advertiment',
  WEBSITE: 'Website',
  WIDTH_KEY: 'Amplada',
  YOU_CAN_ALWAYS_ACCESS: 'You can always access your designs in ',
  YOUR_NAME_KEY: 'El vostre nom',
  YOUR_SELECTION_WILL_KEY:
    'Your selection will become your default printing path for future print outs.',
  YOUR_PROJECT_KEY: 'El vostre projecte',
  PROJECT_NAME_ERROR_TEXT: 'Introduïu un nom pel vostre projecte.',
  PROJECT_FOLDER_ERROR_TEXT:
    'Introduïu un nom per la vostra carpeta de projecte.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Pixel warning settings',
  MINIMUM_VIEWING_DISTANCE_KEY: 'Distància de visualització mínima',
  BACKGROUND_UPLOAD_KEY: ' background ',
  OBJECT_UPLOAD_KEY: ' object ',
  PHOTO_UPLOAD_KEY: ' photo ',
  NO_DREAMSTIME_ERROR_MESSAGE: 'No hi ha contingut dreamstime trobat',
  NO_ELEMENT_ERROR_MESSAGE: "No s'ha trobat cap element.",
  NO_MORE_IMAGES_FOUND_KEY: 'No s’han trobat més imatges',
  NO_PATTERN_ERROR_MESSAGE: "No s'ha trobat cap patró.",
  TOUR_DESCRIPTION_TEXT:
    'Let us walk you through the design process. Remember you can re-open the tour at any time by clicking on the help icon.',
  TEXT_ANCHOR_MIDDLE: 'Center',

  ALREDY_HAVE_AN_ACCOUNT: 'Already have a {0} account?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Change to {0}',
  DOWNLOADS_KEY: '{0} downloads',
  HEX_COLOR_KEY: 'Hex color: {0}',
  NEAR_KEY: 'Near',
  FAR_KEY: 'Far',
  CLOSE_UP_KEY: 'Close Up',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'The images you are trying to use are either smaller or larger than the design area you are using.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'To get better results use a {0} X {1} resolution image',
  MESSAGE_KEY: 'Missatge:',
  VIEWS_KEY: '{0} views',
  COST_DESCRIPTION_MESSAGE_KEY:
    'This is the summary of the cost related to the premium content included in your design. {0} By selecting finish you agree to be charged the following cost by the content providers.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} is your default printing option,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    'you will recieve $100 worth of high-resolution images {0} to help with all your creative needs!', // change the string
  REGISTER_PATTERNSUB3:
    'Sign up today and over the course of the next 30 days, download creative files from our content base of 25 million photos, and see how {0} can help you meet your creative needs.', // change the string
  ZOOM_WARNING_PIXELATED_TEXT:
    'Ho heu ajustat a un punt on la vostra imatge impresa pot tenir un aspecte pixel.lat al visualitzar-la a {0} {1} * (la resolució d&apos;impressió actual és {2} dpi).',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'La distància de visualització recomanada seria de {0} {1}. Si no és l&apos;adequada, reduïu l&apos;escala d&apos;aquesta imatge o la mida de les vostres imatges de paret.',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'La mida mínima recomanada ha de ser de {0} x {1} píxels.',
  UPLOAD_STATUS: '{0}% of {1}MB',
  REGISTER_TO: 'Register to {0}',
  MINIMUM_DIMENSIONS_KEY:
    'Les dimensions mínimes són {0} (amp.) per {1} (alç.).',
  MINIMUM_HEIGHT_KEY: "L'alçada màxima és {0}.",
  MINIMUM_WIDTH_KEY: "L'amplada mínima és {0}.",
  MAXIMUM_DIMENSIONS_KEY: 'Maximum dimensions are {0} (w) by {1} (h).',
  MAXIMUM_WIDTH_KEY: "L'amplada màxima és {0}",
  MAXIMUM_HEIGHT_KEY: "L'alçada màxima és {0}.",
  INVALID_NUMBER_ERROR_TEXT_KEY: 'Inseriu mides numèriques superiors a cero.',
  PROCESSING_FAILED: 'Error al processar, proveu-ho més tard',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT: 'No s’admeten PDF xifrats.',
  DROPBOX_UPLOAD_PROGRESS_KEY: "S'està important el fitxer {0} de {1}",
  RECOLORING_KEY: "S'està tornant a aplicar color...",
  TEXT_COLOR_KEY: 'Text Color',
  SOLID_COLOR_KEY: 'Solid Color',
  AUTHENTICATE_DIALOG_TITLE:
    "L'origen d'aquest contingut està protegit amb contrasenya",
  AUTHENTICATE_FAILED_MESSAGE: "S'ha produït un error d'autenticació!",
  DROPBOX_IMPORT_ERROR_HEADER:
    "S'ha produït un problema en importar alguns fitxers",

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
    'Ho sentim, però no s&apos;admenten PDFs de múltiples pàgines.',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'Project',
  INSPIRATION_SIZE_CHANGE_WARNING:
    "Aquesta plantilla d'inspiració inclou una mida predeterminada de {0} X {1} {2}. La mida de la vostra pàgina es canviarà automàticament per adaptar-se a aquesta plantilla.",

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Choose your laptop',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'First name',
  LAST_NAME_KEY: 'Last name',
  PHONE_NUMBER_KEY: 'Phone No.',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Invalid phone number',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'I accept the terms and conditions.',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'I accept that my personal information will be shared with HP to be contacted about future HP campaigns. *',
  SERVICE_PROVIDER_CONDITION:
    'I accept that the data I provide may be shared with service providers for the purposes of printing and delivery process.',
  ORDER_DESIGN: 'Order design',
  SUBMIT_YOUR_DESIGN: 'Submit your design',
  SUBMISSION_DESIGN_ORDER: 'Submission for design order',
  ENTER_REQUIRED_FIELDS_KEY: 'Please enter required fields',
  ADDRESS_KEY: 'Address',
  INVALID_ADDRESS_KEY: 'Invalid address',
  CITY_KEY: 'City',
  INVALID_CITY_KEY: 'Invalid city',
  COUNTRY_KEY: 'Country',
  STATE_KEY: 'State',
  ZIP_KEY: 'Zip',
  INVALID_ZIP_KEY: 'Invalid zip code',
  ORDER_NUMBER: 'Order number',
  YOUR_DETAILS_KEY: 'Your details',
  APPLY_DESIGN_COMPETITION: 'Apply for the design competition',
  NOTICE_KEY: 'Avís:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'Per tenir una pell de PC perfectament adaptada a la vostra, heu de seleccionar el model exacte corresponent a la compra, tal com es veu a la factura.',
  RESTART_PROJECT_ALERT_TITLE: 'Restart a project ?',
  DISCARD_ALERT_MESSAGE: 'Your current project will be discarded',
  RESTART: 'Restart',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'Avís de la mida de la pàgina',
  MODIFY_SIZE_WARNING:
    'Si voleu redimensionar aquest disseny, podeu fer-ho a la pestanya "Configuració". Els elements de disseny poden necessitar l\'edició per ajustar-se a les dimensions desitjades.',
  RANDOMIZE_KEY: 'Randomitzar',
  MATERIAL_CHOICE_APPLIED: 'Elecció de material aplicada.',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  BLOCKCHAIN_STRING: 'Blockchain',
  CERTIFICATE_STRING: 'certificat de',
  AUTHENTICITY_STRING: 'autenticitat',
  PLEASE_WAIT: 'espereu',
  PROTECTING_YOUR_DATA: 'protegint les vostres dades...',
  SEARCH_YOUR_LAPTOP_KEY: 'Cerca al portàtil', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'Vaja! No hem trobat ordinadors portàtils per a la vostra cerca.', // Google translated

  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  SERIAL_NUMBER_KEY: 'Número de sèrie',
  LOCKED_PROJECT: 'Projecte blocat',
  LOCKED_MESSAGE:
    'Aquest projecte s&apos;ha sol.licitat i no pot modificar-se. Només pot visualitzar-lo.',
  EXPIRED_PROJECT: 'Projecte caducat',
  EXPIRED_MESSAGE: 'Aquest projecte ha caducat.',
  DELETED_PROJECT: 'Projecte suprimit',
  DELETED_MESSAGE: "Aquest projecte s'ha suprimit.",
  CHOOSE_GROUP_TYPE: 'Tria el tipus de {0}',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'Introduïu nombres per sobre de cero.',
  SIZE_KEY: 'Mida',
  DISTANCE_FROM_KEY: 'Distància des de',
  MYROOM_UPPERCASE_KEY: 'MY ROOM',
  FURNITURE_KEY: 'Furniture',
  FIXTURES_KEY: 'Fixtures',
  ADD_A_WALL_KEY: 'Add a wall',
  SELECT_A_WALL_KEY: 'Select a Wall',
  LEFT_KEY: 'Esquerra',
  RIGHT_KEY: 'Dreta',
  DELETE_WALL_KEY: 'Delete a wall',
  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Choose canvas type',
  MAXIMUM_WALL_SIZE_KEY: 'La mida màxima de la paret és {0} quadrats{1}.',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY:
    "L'alçada del llenç supera l'alçada de la paret.",
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY:
    'Ширината на платното надхвърля ширината на стената.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    "El número màxim de columnes per l'amplada actual és {0}",
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    "El número màxim de files per l'alçada actual és {0}",
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    "L'amplada de la paret es menor que l'amplada del llenç.",
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY:
    'La paret ha de tenir una amplada mínima de {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY:
    'La paret ha de tenir una alçada mínima de {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    "L'alçada de la paret es menos que l'alaçada del llenç.",
  MAXIMUM_WALL_HEIGHT_KEY: 'L&apos;alçada màxima de la paret és {0} {1}.',
  FINISHING_KEY: 'Finishing',
  MIRROR_KEY: 'Mirror',
  NATURAL_KEY: 'Natural',
  ROWS_KEY: 'Files',
  COLUMNS_KEY: 'Columnes',
  DEFAULT_WALL_SIZE_KEY: 'Default Wall Size',
  EDIT_KEY: 'Editar',
  TOP_KEY: 'Part superior',
  BOTTOM_KEY: 'Part inferior'
};
